<p>common-base works!</p>
